//chainId
export const UPDATE_MASTER_HOTEL = "UPDATE_MASTER_HOTEL";